import { IntlProvider } from 'react-intl';
import React from 'react';
import merge from 'lodash.merge';
import localeMessages from './locales';
export var defaultLocale = 'de-DE';
export var sanitizeLocale = function (navigatorLanguage, fallbackLocale) {
    if (fallbackLocale === void 0) { fallbackLocale = 'de-DE'; }
    switch (navigatorLanguage) {
        case 'de-DE':
        case 'de-AT':
        case 'de-CH':
        case 'fr-CH':
            return navigatorLanguage;
        default:
            return fallbackLocale;
    }
};
export var getUserLocale = function (fallback) {
    if (fallback === void 0) { fallback = defaultLocale; }
    if (typeof window !== 'undefined') {
        var htmlAttributeLang = document.getElementsByTagName('html')[0].getAttribute('lang');
        if (htmlAttributeLang) {
            return sanitizeLocale(htmlAttributeLang, fallback);
        }
        if (window.navigator) {
            return sanitizeLocale(window.navigator.language, fallback);
        }
    }
    return fallback;
};
export var Provider = function (_a) {
    var children = _a.children, locale = _a.locale, _b = _a.messages, messages = _b === void 0 ? {} : _b;
    var providerMessages = merge({}, localeMessages[locale], messages || {});
    return (React.createElement(IntlProvider, { defaultLocale: "en", key: locale, locale: locale, messages: providerMessages }, children));
};
export default Provider;
//# sourceMappingURL=index.js.map